import { palette } from '@livable/saas-react-components';
import { makeStyles } from '@mui/styles';
const useStyles = makeStyles({
  root: {
    minWidth: 0
  },
  title: {
    fontWeight: 600,
    marginBottom: 4
  },
  updating: {
    display: 'block',
    color: palette.shades[600],
    marginBottom: 4
  },
  timeline: {
    padding: 0,
    margin: 0,
    '& .MuiTimelineItem-root': {
      minHeight: 56
    },
    '& .MuiTimelineItem-root:before': {
      flex: 0,
      padding: 0
    },
    '& .MuiTimelineContent-root': {
      paddingRight: 0,
      paddingTop: 0,
      paddingBottom: 16
    }
  },
  dot: {
    boxShadow: 'none',
    margin: '4px 0',
    padding: 3,
    borderWidth: 2
  },
  dotMuted: {
    backgroundColor: palette.shades[500],
    borderColor: palette.shades[500]
  },
  dotToday: {
    backgroundColor: palette.primary.main,
    borderColor: palette.primary.main
  },
  dotEffective: {
    backgroundColor: palette.warning.main,
    borderColor: palette.warning.main
  },
  dotCharge: {
    backgroundColor: palette.error.main,
    borderColor: palette.error.main
  },
  dotPlaceholder: {
    backgroundColor: 'transparent',
    borderColor: palette.shades[500],
    borderStyle: 'dashed'
  },
  connector: {
    backgroundColor: palette.shades[400]
  },
  connectorDashed: {
    width: 0,
    backgroundColor: 'transparent',
    borderLeft: "2px dashed ".concat(palette.shades[500])
  },
  itemTitle: {
    fontWeight: 600,
    lineHeight: 1.3
  },
  itemTitlePlaceholder: {
    fontWeight: 600,
    lineHeight: 1.3,
    color: palette.shades[600]
  },
  itemCaption: {
    display: 'block',
    color: palette.shades[600],
    lineHeight: 1.4
  }
});
export default useStyles;